import React, {useState, useEffect} from 'react'
import {
    Flex,
    Drawer,
    DrawerOverlay,
    DrawerHeader,
    Text,
    DrawerBody,
    DrawerFooter,
    DrawerContent,
    Stack,
    useStyleConfig,
    Button,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CloseIcon} from '../../icons'
import PropTypes from 'prop-types'
import RecipeFilterModalCategories from './recipe-filter-modal-categories'
import {getSelectedFiltersFromUrl} from '../utils/recipe-search-params-utils'
import {useLocation, useHistory} from 'react-router-dom'
import {FormattedMessage} from 'react-intl'

const RecipesFilterModal = ({isOpen, onClose, drawerPlacement, filters}) => {
    const styles = useStyleConfig('ProductFilterDrawer', {variant: 'freeItemPromo'})
    const location = useLocation()
    const history = useHistory()
    const [tempSelectedFilters, setTempSelectedFilters] = useState(
        () => getSelectedFiltersFromUrl(location) || {},
    )
    const handleApply = () => {
        const searchParams = new URLSearchParams()

        Object.entries(tempSelectedFilters).forEach(([key, values]) => {
            if (values && values.length > 0) {
                const valueString = values.map((v) => v.contentstackValue).join(',')
                searchParams.set(key, valueString)
            }
        })

        history.push({
            pathname: location.pathname,
            search: searchParams.toString(),
        })
        onClose()
    }

    const handleClose = () => {
        onClose()
    }

    useEffect(() => {
        if (isOpen) {
            setTempSelectedFilters(() => getSelectedFiltersFromUrl(location) || {})
        }
    }, [isOpen])

    return (
        <Drawer
            variant="filter"
            isOpen={isOpen}
            onClose={onClose}
            placement={drawerPlacement}
            closeOnEsc
            closeOnOverlayClick
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader {...styles?.header}>
                    <Flex {...styles?.titleContainer}>
                        <Text {...styles?.headerText} justifyContent={'center'} w="100%">
                            <FormattedMessage
                                id="recipes.listing_page.recipe_filter_modal.title"
                                defaultMessage="Filters"
                            />
                        </Text>

                        <CloseIcon onClick={onClose} {...styles?.closeButton} />
                    </Flex>
                </DrawerHeader>

                <DrawerBody {...styles?.body}>
                    {filters &&
                        filters?.map((filter, idx) => {
                            return (
                                <RecipeFilterModalCategories
                                    key={`${filter?.fieldUID}_${idx}`}
                                    filter={filter}
                                    isOpen={isOpen}
                                    tempSelectedFilters={tempSelectedFilters}
                                    setTempSelectedFilters={setTempSelectedFilters}
                                />
                            )
                        })}
                </DrawerBody>

                <DrawerFooter display="block" width="full" height="auto">
                    <Stack>
                        <Button
                            variant="primary"
                            onClick={() => {
                                handleApply()
                            }}
                        >
                            <FormattedMessage
                                id="recipes.listing_page.recipe_filter_modal.apply_button"
                                defaultMessage="Apply"
                            />
                        </Button>
                        <Button variant="secondary" onClick={() => handleClose()}>
                            <FormattedMessage
                                id="recipes.listing_page.recipe_filter_modal.cancel_button"
                                defaultMessage="Cancel"
                            />
                        </Button>
                    </Stack>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    )
}
RecipesFilterModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    drawerPlacement: PropTypes.string,
    filters: PropTypes.array,
    selectedFilters: PropTypes.object,
    setSelectedFilters: PropTypes.func,
    handleModalSubmit: PropTypes.func,
}

export default RecipesFilterModal
